import classnames from "classnames";

interface SelectTypeProps {
  label: string;
  icon?: React.ReactNode;
  className?: string;
  handleClick: (label: string) => void;
}

const wrapperClassnames = (className?: string) =>
  classnames(
    {
      "flex items-center gap-2": true,
    },
    className,
  );

const SelectType = ({
  label,
  className,
  handleClick,
}: SelectTypeProps) => {
  return (
    <div
      className={`cursor-pointer rounded-md border px-3 py-2 text-sm ${wrapperClassnames(
        className,
      )}`}
      onClick={() => handleClick(label)}
    >
      {/* {icon && icon} */}
      <p className="text-neutral-primary">{label}</p>
    </div>
  );
};

export default SelectType;
